import React, { useEffect, useState } from "react";
import User from "../../Services/userServices";
import TitleHeader from "../accounts/Components/TitleHeader";
import Footer from "../../Components/Footer";

function SuperuserDashboard(props) {
  const [branches, setBranches] = useState();
  const getBranches = () => {
    User.getBranches()
      .then((response) => {
        setBranches(response.data);
      })
      .catch((error) => {
        console.log("___+ error in branchess", error);
      });
  };
  useEffect(() => {
    getBranches();
  }, []);

  return (
    <div class="container" style={{ marginTop: 100 }}>
      <div class="content">
        <div class="row">
          <TitleHeader title="Super User" />
          {branches?.map((branch) => (
            <a
              class="col-lg-3 col-sm-6 col-12 d-flex"
              href={`/branch-details/${branch.id}`}
            >
              <div class="dash-count das2">
                <div class="dash-counts">
                  <h4>
                    {branch.name} ({branch.baseCurrencyName})
                  </h4>
                  <p>{branch.createdDate}</p>
                  <h5>
                    {branch.email}-{branch.mobile}
                  </h5>
                  <p>{branch.description}</p>
                </div>
                <div class="dash-imgs">
                  <i data-feather="user"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SuperuserDashboard;
